/** @jsx jsx */
import { jsx } from "theme-ui"

const Footer = () => (
  <footer
    className="site-footer"
    sx={{
      bg: "siteColor",
    }}
  >
    <div className="container">
      <p>
      <small>&copy; Copyright 2026, Moks Auto. All Rights Reserved</small>
      </p>
    </div>
  </footer>
)

export default Footer
